import { render } from "./RoleConstructor.vue?vue&type=template&id=c281bbe0&scoped=true"
import script from "./RoleConstructor.vue?vue&type=script&lang=js"
export * from "./RoleConstructor.vue?vue&type=script&lang=js"

import "./RoleConstructor.vue?vue&type=style&index=0&id=c281bbe0&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c281bbe0"]])

export default __exports__